import { sellHttpApi } from "api";

export interface IPackage {
  _id: string;
  name: string;
  code: string;
  status: string;
  donateUnsoldItems: boolean;
  seller: {
    credits: number;
    date: string;
    email: string;
    name: string;
    phoneNumber: number;
    role: number;
    uid: string;
    username: string;
    _id: string;
  };
  totalItemsCount?: number;
  itemsCountByStatus?: Record<string, number>;
  createdAt: string;
  shouldSchedulePickup: boolean;
  commissionTier: string;
}

export interface IRequestPackageResponse extends Response {
  packages: IPackage[];
}

export async function requestGetPackages() {
  const response = await sellHttpApi.makeAuthenticatedRequest<IRequestPackageResponse>("/packages?sortBy=name&sortOrder=asc&limit=100", {
    method: "GET",
  });
  return response.json();
}
